import { grey } from "@mui/material/colors";

const styles = {
  mainContainer: {
    minHeight: "100%",
    backgroundColor: grey[100],
    padding: "24px",
  },
};

export default styles;
